export default {
  data () {
    return {
      markerPopup: {},
      head: null,
      rows: {},
      fields: {},
      loading: true
    }
  },
  destroyed () {
    if (this.destroySubs) {
      this.destroySubs.unsubscribe()
    }
  },
  methods: {
    registerVueInMap () {
      this.destroySubs = this.$emitter.listen('geo.destroyMap', (data) => {
        this.$destroy()
      })
    },
    fetchGeoObjectPopupData (endpoint) {
      this.loading = true
      this.$sharedServices.dispatch('updateUrlEndpoint', {
        endpoint: endpoint,
      }).then(r => {
        this.rows = Object.assign({}, r.data.fields)
        this.head = r.data.head
        this.fields = r.data.model
        console.log(r)
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
